import React from 'react';
import PlantAreaBox from './PlantAreaBox';
import PlantAreaButtons from './PlantAreaButtons';

const PlantAreaList = (props) => {
  if (props.isLoading) {
    return (
      <div className="flex flex-wrap animate-pulse">
        {[...Array(4)].map((e, i) => (
          <SkeletonPlantArea isLoggedin={props.isLoggedin} key={i} />
        ))}
      </div>
    );
  }

  if (props.fetchedAreas.filter((p) => !p.isDeleted).length === 0) {
    return <div className="mx-auto my-auto font-bold">No Areas Found!</div>;
  }

  return (
    <div className="flex flex-wrap">
      {props.fetchedAreas
        .filter((p) => !p.isDeleted)
        .map((a) => (
          <div
            className="xl:w-1/4 lg:w-1/2 md:w-full w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60"
            key={a.id}
          >
            <PlantAreaBox area={a} showPlants={props.showPlants} />

            {props.isLoggedin && (
              <PlantAreaButtons
                area={a}
                setEditArea={props.setEditArea}
                deleteAreaAndPlants={props.deleteAreaAndPlants}
              />
            )}
          </div>
        ))}
    </div>
  );
};

const SkeletonPlantArea = ({ isLoggedin }) => {
  return (
    <div className="xl:w-1/4 lg:w-1/2 md:w-full w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60">
      <div className="w-28 h-7 bg-gray-200 rounded-full mb-2"></div>
      <div className="w-52 h-[1.625rem] bg-gray-200 rounded-full mb-4"></div>
      <div className="w-6 h-4 bg-gray-200 rounded-full inline-flex items-center ml-2"></div>
      {isLoggedin && (
        <div className="w-12 bg-gray-200 rounded-full h-5 mt-3"></div>
      )}
    </div>
  );
};

export default PlantAreaList;
